<template>
	<div :id="`block-${$vnode.key}`" class="c-block-list-accordion">
		<LongReadTarget
			v-if="title && showTitleInToc"
			class="relative z-10"
			style="top: 2em"
			:container-id="`block-${$vnode.key}`"
			:link-to-toc="{
				name: `Spring til &quot;${title}&quot; i indholdsfortegnelsen`,
				attrs: {
					'data-focus-ignore': true,
				},
			}"
			:title="title"
		/>
		<AccordionLayout :title="title" :elements="elements">
			<template #panel="{ item }">
				<BlockList :block-list="item.content.accordionElements" />
			</template>
		</AccordionLayout>
	</div>
</template>

<script>
import { LongReadTarget } from '~/components/shared/LongRead';
import AccordionLayout from '~/components/main/AccordionLayout';
import BlockList from '~/components/main/BlockList';

export default {
	name: 'BlockListInfogram',

	components: {
		LongReadTarget,
		AccordionLayout,
		BlockList,
	},

	inheritAttrs: false,

	props: {
		title: String,
		showTitleInToc: Boolean,
		elements: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="postcss">
.c-block-list-accordion .c-block-list {
	@apply gap-y-lg/v;
}
.c-block-list-accordion
	:where(.c-block-list > .c-block-list-rte + .c-block-list-cta),
.c-block-list-accordion
	:where(.c-block-list > .c-block-list-cta + .c-block-list-cta) {
	margin-top: calc(
		var(--theme-verticalSpacing-xs-v, var(--theme-verticalSpacing-xs-v--sm)) -
			var(
				--theme-verticalSpacing-lg-v,
				var(--theme-verticalSpacing-lg-v--sm)
			)
	);
}
</style>
